/**
 * ArrowDoodle mark: M2.T10c §13.12.
 *
 * Used for "your turn" indicators.
 * A hand-drawn arrow pointing right.
 */
export function ArrowDoodle({ size = 20 }: { size?: number }) {
  return (
    <svg
      class="mark-arrow-doodle"
      viewBox="0 0 20 14"
      width={size}
      height={Math.round(size * 0.7)}
      aria-hidden="true"
    >
      {/* Arrow shaft: slightly wobbly */}
      <path
        d="M 1 7 C 4 6.5 8 7.5 14 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Arrowhead */}
      <path
        d="M 11 3.5 C 14 5 16 6.5 19 7 C 16 7.5 13.5 9 11 10.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
